import request from '@/utils/request'

// 获取数据
export function getData() {
  return request({
    url: '/user/get/statistical-information',
    method: 'get'
  })
}
